/*
 * @Author: Gaho
 * @Date: 2024-02-23 16:07:11
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-08 17:13:57
 * @Description: 
 */
import { aBetCorgiGames } from '@/routes/casinoRoutes';
// 查询所有最新的游戏封面
const newCoversCn = import.meta.glob('~/assets/imgs/casino/originals/new-cover_cn_webp/*.webp', { eager: true });
const newCoversEn = import.meta.glob('~/assets/imgs/casino/originals/new-cover_en_webp/*.webp', { eager: true });
/**
 * 根据游戏名称获取游戏封面
 * @param gameName 游戏名称
 * @returns 游戏名称对应的封面路径
 */
const newGameCovers = (gameName: string) => {
    try {
        const { locale } = useI18n();
        let covers = null;
        let coversPath = null;
        // let currCover = ''
        if (locale.value === 'en') {
            covers = newCoversEn;
            coversPath = '/assets/imgs/casino/originals/new-cover_en_webp/';
            // currCover = enCovers[gameName]
        } else {
            covers = newCoversCn;
            coversPath = '/assets/imgs/casino/originals/new-cover_cn_webp/';
            // currCover = cnCovers[gameName]
        }
        return Object.fromEntries(Object.entries(covers).map(([key, value]: any) => {
            const sKey = key.replace(coversPath, '').replace('.webp', '');
            return [sKey, value.default]
        }))[gameName] || '';
        // return currCover;
    } catch (error) {
        console.log('newGameCovers:', error)
    }
}

export const routes = aBetCorgiGames;

export const getImageUrl = (name: string) => {
    return newGameCovers(name)
}
export const getNewImageUrl = (name: string) => {
    return newGameCovers(name.toLocaleLowerCase())
}